import React, { useState } from 'react';
import { UserAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations';

const EmailVerification = () => {
  const { user, resendEmailVerification } = UserAuth();
  const { lang } = useLanguage();
  const T = translations[lang].emailVerification;

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleResendVerification = async () => {
    try {
      setError("");
      await resendEmailVerification();
      setMessage(T.sent);
    } catch (err) {
      setError(err.message);
    }
  };

  if (!user || user.emailVerified) {
    return null;
  }

  return (
    <div style={{
      backgroundColor: "#fff3cd",
      border: "1px solid #ffeaa7",
      borderRadius: "4px",
      padding: "15px",
      margin: "20px 0",
      textAlign: "center"
    }}>
      <h3 style={{ color: "#856404", margin: "0 0 10px 0" }}>
        {T.title}
      </h3>
      <p style={{ color: "#856404", margin: "0 0 15px 0" }}>
        {T.body}
      </p>

      {error && <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>}
      {message && <div style={{ color: "green", marginBottom: "10px" }}>{message}</div>}

      <button
        onClick={handleResendVerification}
        style={{
          backgroundColor: "#007bff",
          color: "white",
          border: "none",
          borderRadius: "4px",
          padding: "8px 16px",
          cursor: "pointer"
        }}
      >
        {T.resend}
      </button>
    </div>
  );
};

export default EmailVerification;
